import Segment from '../shared/segment';

export type RankingTitlePropsType = {
  examName: string;
};

function ExamRankingTitle({ examName }: RankingTitlePropsType) {
  return (
    <Segment bg noMargin color='indigo' className='my-2'>
      <p className='text-center text-lg font-medium'>رتبه‌های {examName}</p>
    </Segment>
  );
}

export default ExamRankingTitle;
